<ion-grid *ngIf="questionnaire.blockquestions">
    <ion-row class="ion-padding" auto-hide="false" *ngFor="let q of questionnaire.blockquestions">
      <ion-col size="12">
        <app-question-group [legend]="q.title" legendId="gb-{{q.id}}">
          <ion-segment (ionChange)="segmentChanged($event)" [(ngModel)]="q.answer" expand="block">
            <ion-segment-button value="1" [attr.aria-labelledby]="'gb-'+q.id+' gb-'+q.id+'-yes'">
              <ion-label id="gb-{{q.id}}-yes">Yes</ion-label>
            </ion-segment-button>
            <ion-segment-button value="0" [attr.aria-labelledby]="'gb-'+q.id+' gb-'+q.id+'-no'">
              <ion-label id="gb-{{q.id}}-no">No</ion-label>
            </ion-segment-button>
          </ion-segment>
        </app-question-group>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="questionnaire.numericquestions">
    <ion-row class="ion-padding" auto-hide="false" *ngFor="let q of questionnaire.numericquestions">
      <ion-col size="12">
        <app-question-group [legend]="q.title" legendId="gn-{{q.id}}">
          <ion-segment [(ngModel)]="q.answer" expand="block">
            <ion-segment-button [value]="response.id" *ngFor="let response of q.responses; let j = index" [attr.aria-labelledby]="'gn-'+q.id+' gn-'+q.id+'-'+j">
              <ion-label><div id="gn-{{q.id}}-{{j}}" [innerHTML]="response.label"></div></ion-label>
            </ion-segment-button>
          </ion-segment>
        </app-question-group>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid>
    <ion-row>
      <ion-col class="ion-text-center" size="12">
        Please submit
      </ion-col>
      <ion-col  class="ion-text-center" size="12">
        <ion-button (click)="submit()" color="success">{{ 'common.ok' | translate }}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>